import { render, staticRenderFns } from "./modalAdvertencia.vue?vue&type=template&id=2b2393ce&"
import script from "./modalAdvertencia.vue?vue&type=script&lang=js&"
export * from "./modalAdvertencia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports